import React, { useContext, useEffect, useRef, useState } from 'react'
import './Auditcontents.css'
import { UilSetting } from '@iconscout/react-unicons'
import Auditnew from "../../imgs/auditnew.png";
import Trial from "../../imgs/trial.png";
import profitloss from "../../imgs/profitloss.png";
import balancesheet from "../../imgs/balancesheet.png";
import gournal from "../../imgs/gournal.png";
import rojkird from "../../imgs/rojkird.png";
import accountbook from "../../imgs/accountbook.png";
import qr from "../../imgs/QR.png";
import vyapari from "../../imgs/vyapari.png";
import Box from '../Box/Box';
import Cowleft from "../../imgs/cowleft.gif";
import { useNavigate } from 'react-router-dom';
import Dialog from '../Dialog/Dialog';
import Globalcontext from '../../Context/Globalcontext';
import { toast } from 'react-toastify';

import Newaudit from '../Newaudit/Newaudit';
import Auditentry from '../Auditentry/Auditentry';
import Khatevahi from '../Khatevahi/Khatevahi';
import Terijpatrak from '../Terijpatrak/Terijpatrak';
import Vyaparipatrak from '../Vyaparipatrak/Vyaparipatrak';
import Profitloss from '../Profitloss/Profitloss';
import Taleband from '../Taleband/Taleband';
import Rojkird from '../Rojkird/Rojkird';
import Settingslinking from '../Settingslinking/Settingslinking';

import { useTranslation } from "react-i18next";

const Audiocontents = (props) => {

    const [mastermenu, setMastermenu] = useState(true);
    const [showBackImage, setShowBackImage] = useState(false);
    const [transitionEnded, setTransitionEnded] = useState(true);
    const [kopen, setkopen] = useState(0);
    const [expirebox, setExpirebox] = useState(false);

    const { submenu, setsubmenu } = useContext(Globalcontext);
    const { newcustsource, kendrasource, setHeadname } = useContext(Globalcontext);

    const notify = (msg) => toast(msg);

    const [t] = useTranslation();

    const [daysRemaining, setDaysRemaining] = useState(0);
    const refprint = useRef(null);
    const refprintclose = useRef(null);

    const navigate = useNavigate();

    const [dialog, setDialog] = useState({
        message: "",
        isLoading: false,
        nameProduct: ""
    });

    useEffect(() => {
        if (newcustsource === "sank") {
            setShowBackImage(true);
            setMastermenu(false);
            setTransitionEnded(true);
            if (submenu === "customer") setkopen(0);
        }

        if (localStorage.getItem('contact') === "9975337297") {
            const currentDate = new Date();
            const targetDate = new Date(localStorage.getItem("vdate"));
            const differenceInTime = targetDate.getTime() - currentDate.getTime();
            const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
            setDaysRemaining(differenceInDays);

            if (differenceInDays <= 7) {
                handlePrint();
                setExpirebox(true);
            }
        }
    }, [])

    const areUSure = () => {
        handleDialog("", false);
    };

    const handleDialog = (message, isLoading, nameProduct) => {
        setDialog({ message, isLoading, nameProduct });
    };

    const showdialog = () => {
        setkopen(1);
        handleDialog(t("dialog.kendra_not_available"), true, t("dialog.create_new_kendra"));
    }

    const openkendra = () => {
        setShowBackImage(true);
        setMastermenu(false);
        setTransitionEnded(true);
        setsubmenu("kendra");
        setkopen(1);
    }

    useEffect(() => {
        if (newcustsource === "sank") {
            setShowBackImage(true);
            setMastermenu(false);
            setTransitionEnded(true);
            if (submenu === "customer") setkopen(0);
        }

        if (kendrasource === "Dashboard" || kendrasource === "Transection") {
            setShowBackImage(true);
            setMastermenu(false);
            setTransitionEnded(true);
            if (submenu === "kendra") setkopen(1);
        }

        if (localStorage.getItem("contact") === "" || localStorage.getItem("contact") === null) {
            navigate("/");
            localStorage.setItem("status", "");
            localStorage.setItem("contact", "");
        }

        if (localStorage.getItem("kendra") === "Not available" && kopen === 0) {
            showdialog();
        }
    })

    const visibility = () => {
        localStorage.setItem("glcustsr", "");
        setTransitionEnded(false);
        setMastermenu(!mastermenu);
        setkopen(0);
        setHeadname(t("head.audit")); // ✅ translated
    }

    const handleTransitionEnd = () => {
        if (!mastermenu) setShowBackImage(true);
        else setShowBackImage(false);
        setTransitionEnded(true);
    };

    const handlePrint = () => {
        refprint.current?.click();
    }

    const openratib = () => {
        setShowBackImage(true);
        setMastermenu(false);
        setTransitionEnded(true);
        setsubmenu("auditlinking");
        setHeadname(t("audit.linking_title"));
    };

    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        return `${day} ${monthNames[monthIndex]} ${year}`;
    }

    const handleprintclose = () => {
        refprintclose.current?.click();
    }

    const logout = () => {
        localStorage.setItem("status", "");
        localStorage.setItem("contact", "");
        localStorage.setItem("contactplant", "");
        localStorage.setItem("kendra", "Not available");
        localStorage.setItem("kmobno", "");
        localStorage.setItem("ksr", "");
        localStorage.setItem("vdate", "");

        localStorage.setItem("thevregular", "");
        localStorage.setItem("thev1", "");
        localStorage.setItem("thev2", "");
        localStorage.setItem("thev3", "");
        localStorage.setItem("advchalu", "");
        localStorage.setItem("advkapat", "");
        localStorage.setItem("khchalu", "");
        localStorage.setItem("khkapat", "");
        localStorage.setItem("ratibchalu", "");
        localStorage.setItem("ratibkapat", "");
        localStorage.setItem("hptachalu", "");
        localStorage.setItem("intrchalu", "");
        localStorage.setItem("sanghkchalu", "");
        localStorage.setItem("sanghkkapat", "");
        localStorage.setItem("retanchalu", "");
        localStorage.setItem("retankapat", "");
        localStorage.setItem("kapat1", "");
        localStorage.setItem("kapat2", "");
        localStorage.setItem("kapat3", "");
        localStorage.setItem("vahtuk", "");
        localStorage.setItem("comm", "");
        localStorage.setItem("ada", "");
        localStorage.setItem("billamt", "");

        props.setProgress(50);
        setTimeout(() => props.setProgress(100), 200);

        navigate("/");
        notify(t("common.logged_out"));
    }

    return (
        <>
            {/* Expiry modal - translated */}
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden={true}
                ref={refprint}
                data-bs-target="#printinput"
            />

            <div className="modal fade" id="printinput" tabIndex="-1" role="dialog" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprintclose} aria-label="Close" />
                        </div>

                        <div className="modal-body">
                            <h5 className="modal-title">{t("expiry.title")}</h5>
                            <span className='note'>{t("expiry.note")}</span>
                        </div>

                        <div className="expiry">
                            <span className='noteblue'>
                                {t("expiry.line1", {
                                    date: formatDate(localStorage.getItem("vdate")),
                                    days: daysRemaining
                                })}
                            </span>
                            <span className='noteblue'>{t("expiry.line2")}</span>
                            <span className='noteblue'>{t("expiry.line3")}</span>
                            <span className='noteblue'>{t("expiry.line4")}</span>

                            <span className='noteblack'>{t("expiry.scan_qr")}</span>
                            <img className='qrimg' src={qr} alt="" />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprintclose}>
                                {t("common.close")}
                            </button>
                            <button type="button" className="btn btn-danger" onClick={handleprintclose}>
                                {t("common.ok")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='line' />

            <div className="rowaudit">
                <div className="mainconaudit">
                    <span className={`heading1 ${mastermenu ? '' : 'hidden'}`}>{t("audit.section_title")}</span>
                    <div className={`Dashcontents ${mastermenu ? '' : 'hidden'}`} onTransitionEnd={handleTransitionEnd}>
                        <Box
                            action="auditnew"
                            setsubmenu={setsubmenu}
                            visibility={visibility}
                            background={"linear-gradient(179deg, var(--t1dark), var(--t1dark))"}
                            head={t("audit.boxes.audit_account")}
                            img={<img src={Auditnew} alt="" />}
                        />
                        <Box
                            action="auditentry"
                            setsubmenu={setsubmenu}
                            visibility={visibility}
                            background={"linear-gradient(179deg, var(--t4dark), var(--t4dark))"}
                            head={t("audit.boxes.audit_entry")}
                            img={<img src={gournal} alt="" />}
                        />
                    </div>
                </div>

                <div className="mainconaudit2">
                    <span className={`heading1 ${mastermenu ? '' : 'hidden'}`}>{t("audit.reports_title")}</span>
                    <div className={`Dashcontents ${mastermenu ? '' : 'hidden'}`} onTransitionEnd={handleTransitionEnd}>
                        <Box action="rojkird" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t1dark), var(--t1dark))"} head={t("audit.boxes.rojkird")} img={<img src={rojkird} alt="" />} />
                        <Box action="khatevahi" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t3dark), var(--t3dark))"} head={t("audit.boxes.khatevahi")} img={<img src={accountbook} alt="" />} />
                        <Box action="terij" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t5dark), var(--t5dark))"} head={t("audit.boxes.terij")} img={<img src={Trial} alt="" />} />
                        <Box action="vyapari" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t2), var(--t2))"} head={t("audit.boxes.vyapari")} img={<img src={vyapari} alt="" />} />
                        <Box action="profitloss" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t6dark), var(--t6dark))"} head={t("audit.boxes.profitloss")} img={<img src={profitloss} alt="" />} />
                        <Box action="taleband" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t2dark), var(--t2dark))"} head={t("audit.boxes.taleband")} img={<img src={balancesheet} alt="" />} />
                    </div>
                </div>
            </div>

            <div className={`rowbox ${mastermenu ? '' : 'hidden'}`}>
                <div className="first"></div>
                <div className="second" onTransitionEnd={handleTransitionEnd}>
                    <div className='lineaudit' />
                    <span className='firstspan'>{t("audit.info.1")}</span>
                    <span className='infospan'>{t("audit.info.2")}</span>
                    <span className='infospan'>{t("audit.info.3")}</span>
                    <span className='infospan' onClick={openratib}>
                        {t("audit.info.4")} <UilSetting className='settingaudit' />
                    </span>
                </div>
            </div>

            <div className={`cust ${mastermenu ? 'hidden' : ''}`}>
                {transitionEnded && showBackImage && (
                    submenu === "auditnew" ? <Newaudit setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                        submenu === "auditentry" ? <Auditentry setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                            submenu === "khatevahi" ? <Khatevahi setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                submenu === "terij" ? <Terijpatrak setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                    submenu === "vyapari" ? <Vyaparipatrak setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                        submenu === "profitloss" ? <Profitloss setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                            submenu === "taleband" ? <Taleband setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                submenu === "rojkird" ? <Rojkird setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                    submenu === "auditlinking" ? <Settingslinking setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                        ""
                )}
            </div>

            <div className="secrow">
                <div className="leftsecrow"></div>
                {submenu !== "auditnew" && submenu !== "auditentry" && submenu !== "khatevahi" && submenu !== "terij" && submenu !== "vyapari" && submenu !== "profitloss" && submenu !== "taleband" && submenu !== "rojkird" && submenu !== "auditlinking" ?
                    <div className="imgcon">
                        <img className='imgcowdash' src={Cowleft} alt="" />
                    </div>
                    : ""
                }
            </div>

            {dialog.isLoading && (
                <Dialog
                    submessage={dialog.nameProduct}
                    onDialog={areUSure}
                    message={dialog.message}
                    functionname={openkendra}
                    button1text={t("dialog.no")}
                    button2text={t("dialog.yes")}
                />
            )}
        </>
    )
}

export default Audiocontents
